import { useEffect } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";

import { isSupabaseConfigured } from "@/services/supabase-client.service";
import {
    listMyPendingApprovals,
    subscribeToMyPendingOrders,
} from "@/services/pending-approvals.service";

export const pendingApprovalsKeys = {
    all: ["pending-approvals"] as const,
    count: () => [...pendingApprovalsKeys.all, "count"] as const,
};

export function usePendingApprovalsCountQuery(enabled: boolean) {
    const queryClient = useQueryClient();

    useEffect(() => {
        if (!enabled || !isSupabaseConfigured()) return;
        const channel = subscribeToMyPendingOrders(() => {
            void queryClient.invalidateQueries({
                queryKey: pendingApprovalsKeys.count(),
            });
        });
        return () => {
            void channel.unsubscribe();
        };
    }, [enabled, queryClient]);

    return useQuery({
        queryKey: pendingApprovalsKeys.count(),
        queryFn: async () => {
            const items = await listMyPendingApprovals();
            return { total: items.length };
        },
        enabled: enabled && isSupabaseConfigured(),
        staleTime: 30_000,
    });
}
